import React      from "react";
import { Button } from "reactstrap";

const FacebookButton = ({color})=> {

  const fbAuth = ()=> {
    const queryParams   = new URLSearchParams({
      client_id     : process.env.REACT_APP_LOGIN_WITH_FACEBOOK_ID,
      redirect_uri  : `${window.location.origin}/facebook-oauth2-callback/`,
      response_type : "code",
      scope         : "public_profile,email",
    });

    window.location = `https://www.facebook.com/v11.0/dialog/oauth?${queryParams.toString()}`;
  }

  return (
    <Button onClick={fbAuth} color={color} className="btn-lg">
      <i className="fa fa-facebook"></i>
      <span className="m-l-10"> Facebook </span>
    </Button>
  )
};

export default FacebookButton;
